import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NotificationNew"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.4996 13.2V11.25H17.9996V13.5C17.9942 13.6995 18.0764 13.8913 18.2246 14.025L20.2496 16.05V17.25H3.74959V16.05L5.77459 14.025C5.92273 13.8913 6.00494 13.6995 5.99959 13.5V9.75C5.99959 6.43629 8.68588 3.75 11.9996 3.75C13.0546 3.7502 14.0903 4.03245 14.9996 4.5675V2.85C14.2866 2.53061 13.5269 2.32802 12.7496 2.25V0.75H11.2496V2.25C7.42792 2.68567 4.53168 5.90371 4.49959 9.75V13.2L2.47459 15.225C2.32644 15.3587 2.24423 15.5505 2.24959 15.75V18C2.23617 18.2027 2.31088 18.4014 2.45454 18.545C2.5982 18.6887 2.79686 18.7634 2.99959 18.75H8.24959C8.24959 20.8211 9.92852 22.5 11.9996 22.5C14.0707 22.5 15.7496 20.8211 15.7496 18.75H20.9996C21.2023 18.7634 21.401 18.6887 21.5446 18.545C21.6883 18.4014 21.763 18.2027 21.7496 18V15.75C21.7549 15.5505 21.6727 15.3587 21.5246 15.225L19.4996 13.2ZM19.498 9C21.1549 9 22.498 7.65685 22.498 6C22.498 4.34315 21.1549 3 19.498 3C17.8412 3 16.498 4.34315 16.498 6C16.498 7.65685 17.8412 9 19.498 9ZM9.74961 18.75C9.74961 19.9926 10.757 21 11.9996 21C13.2423 21 14.2496 19.9926 14.2496 18.75H9.74961Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/NotificationNew.vue"]]);
